module.exports = "/out/5e7540f6fe98c9681642c404f86297e3.svg";